module.exports = __webpack_public_path__ + "static/media/Rules & Regulations.6daaaf6f.pdf";